export { default as AppSwitchButton } from './AppSwitchButton.vue';
